import axios from 'axios'
import { API_OCR } from '../../config/config.json'
import { decryptStorage } from 'utils/utils';
export async function consultDNI(data) {
  let token = decryptStorage(localStorage.getItem("token"));
  let config = {
    method: 'POST',
    url: `${API_OCR}/dnioptimization`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    },
    data
  }
  return await axios.request(config).then(res => {
    return { data: res.data.data, status: 'success' }
  }).catch(err => {
    console.log("err ", err.message);
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function consultRUT(data) {
  let token = decryptStorage(localStorage.getItem("token"));
  let config = {
    method: 'POST',
    url: `${API_OCR}/rutoptimization`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    },
    data
  }
  return await axios.request(config).then(res => {
    return { data: res.data.data, status: 'success' }
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function consultCYC(data) {
  let token = decryptStorage(localStorage.getItem("token"));
  let config = {
    method: 'POST',
    url: `${API_OCR}/cycoptimization`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    },
    data
  }
  return await axios.request(config).then(res => {
    return { data: res.data.data, status: 'success' }
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function consultRUES(data) {
  let token = decryptStorage(localStorage.getItem("token"));
  let config = {
    method: 'POST',
    url: `${API_OCR}/ruesoptimization`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    },
    data
  }
  return await axios.request(config).then(res => {
    return { data: res.data.data, status: 'success' }
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}